import clsx from "clsx";
import type { ComponentPropsWithoutRef } from "react";

export function NavigationButton({
  disabled,
  onClick,
  children,
  ...props
}: ComponentPropsWithoutRef<"button"> & {
  disabled: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      {...props}
      className={clsx(
        "border-skogecha bg-swhite flex size-[32px] items-center justify-center rounded-full border hover:opacity-60",
        disabled && "opacity-50 hover:cursor-not-allowed",
      )}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
